import React from "react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLang } from "@/LanguageContext";
import { PARTNERS } from "@/lib/clientData";

export default function Partners() {
  const { lang } = useLang();
  const isFr = lang === "fr";
  return (
    <div className="bg-ivory min-h-screen">
      <Navbar />
      <section className="pt-40 pb-14 max-w-[1400px] mx-auto px-6 md:px-10 text-center">
        <div className="flex justify-center items-center gap-4 mb-6">
          <span className="tricolore"><span className="bg-frblue" /><span className="bg-white" /><span className="bg-frred" /></span>
          <span className="text-gold text-xs tracking-luxe uppercase">{isFr ? "Partenaires" : "Partners"}</span>
        </div>
        <h1 className="font-serif-lux text-navy text-4xl sm:text-5xl lg:text-6xl font-light">
          {isFr ? "Nos Maisons Partenaires" : "Our Partner Houses"}
        </h1>
        <p className="text-navy/60 font-light mt-5 max-w-xl mx-auto">
          {isFr
            ? "Une sélection de maisons d'exception qui partagent notre exigence du détail."
            : "A curated circle of exceptional houses that share our devotion to detail."}
        </p>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 md:px-10 pb-28 grid md:grid-cols-3 gap-8">
        {PARTNERS.map((p, i) => (
          <motion.a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`partner-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="group flex flex-col items-center bg-white border border-navy/10 hover:border-gold transition-all duration-500 p-10 hover:-translate-y-1"
          >
            <div className="h-40 flex items-center justify-center w-full">
              <img src={p.logo} alt={p.name} className="max-h-32 max-w-[80%] object-contain transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="gold-line w-12 my-6 opacity-60" />
            <h3 className="font-serif-lux text-navy text-2xl text-center">{p.name}</h3>
            <p className="text-navy/60 text-sm font-light mt-2 text-center">{isFr ? p.fr : p.en}</p>
            <span className="mt-5 text-gold text-xs tracking-luxe uppercase link-gold">
              {isFr ? "Visiter le site" : "Visit website"}
            </span>
          </motion.a>
        ))}
      </section>
      <Footer />
    </div>
  );
}
